// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const EVM_ADDRESS_LENGTH = 44;

// Known EVM anchor sender addresses per network.
// Add new network addresses here as the EVM is deployed to more networks.
export const EVM_ANCHOR_ADDRESSES: string[] = [
    '0x7b4a34f6a011794f0ecbe5e5beb96102d3eef6122eb929b9f50a8d757bfbdd67', // mainnet
];
